var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0534 6.45003L28.6574 14.5515C28.9155 14.6712 28.9634 15.0262 28.7423 15.211L18.5998 23.6668C18.2512 23.9563 18.2783 24.5104 18.6607 24.7672L31.027 33.0113C31.0346 33.0181 31.0286 33.0332 31.0144 33.0342L10.7515 25.7535C10.3168 25.4424 10.3053 25.0255 10.5278 24.5702L20.1435 15.9269C20.3303 15.7593 20.3298 15.4666 20.1528 15.2896L11.0409 6.47292C11.0327 6.45889 11.0387 6.44381 11.0534 6.45003Z",
    fill: "url(#paint0_linear_3589_3878)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3589_3878",
    x1: 7.95757,
    y1: 5.06499,
    x2: 39.4234,
    y2: 24.3947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74ADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314846,
    stopColor: "#31667F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14262F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.f20999969e469abc4c30aaadd1a17967.svg";
export { ForwardRef as ReactComponent };